import d from "clsx";
import * as v from "react";
import e, { forwardRef as r, useState as T, useCallback as oe, useRef as $ } from "react";
import { useFloating as ie, offset as le, arrow as re, size as ce, autoUpdate as de, useClick as _e, useDismiss as me, useRole as pe, useMergeRefs as ue, useInteractions as ge, FloatingOverlay as ve, FloatingArrow as fe } from "@floating-ui/react";
const Ee = "_card_wl4rl_1", we = "_padded_wl4rl_8", Ce = "_flush_wl4rl_20", ye = "_condensed_wl4rl_36", N = {
  card: Ee,
  padded: we,
  "card-group": "_card-group_wl4rl_12",
  flush: Ce,
  condensed: ye
}, be = "div", he = r(
  ({
    as: n,
    className: t,
    children: s,
    condensed: a = !1,
    flushOnMobile: i = !1,
    padded: o = !1,
    ...l
  }, c) => {
    const _ = n ?? be;
    return /* @__PURE__ */ e.createElement(
      _,
      {
        ...l,
        className: d(
          N["card-group"],
          {
            [N.flush]: i,
            [N.condensed]: a,
            [N.padded]: o
          },
          t
        ),
        ref: c
      },
      s
    );
  }
);
he.displayName = "CardGroup";
const xe = "_icon_1i7w6_1", Ne = "_xs_1i7w6_12", ke = "_sm_1i7w6_16", Re = "_base_1i7w6_20", qe = "_lg_1i7w6_24", Ie = "_xl_1i7w6_28", Le = "_x1_1i7w6_32", je = "_x2_1i7w6_36", Me = "_x3_1i7w6_40", Ae = "_x4_1i7w6_44", D = {
  icon: xe,
  xs: Ne,
  sm: ke,
  base: Re,
  lg: qe,
  xl: Ie,
  x1: Le,
  x2: je,
  x3: Me,
  x4: Ae
}, w = r(
  ({ icon: n, label: t, size: s = "base", className: a, ...i }, o) => {
    const l = n;
    return /* @__PURE__ */ e.createElement(
      l,
      {
        "aria-hidden": t ? void 0 : !0,
        "aria-label": t,
        className: d(D.icon, D[s], a),
        ref: o,
        role: t ? "img" : void 0,
        ...i
      }
    );
  }
);
w.displayName = "Icon";
const $e = r(function(t, s) {
  return /* @__PURE__ */ v.createElement(
    "svg",
    {
      fill: "none",
      ref: s,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      ...t
    },
    /* @__PURE__ */ v.createElement(
      "path",
      {
        d: "M16 11L12 15L8 11",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2
      }
    )
  );
}), De = "_summary_1ce70_1", He = "_title_1ce70_16", We = "_titleWrapper_1ce70_21", Be = "_isNested_1ce70_33", Oe = "_isExpanded_1ce70_42", Se = "_chevronIcon_1ce70_47", Te = "_chevronIconExpanded_1ce70_58", Ve = "_dark_1ce70_62", Ze = "_light_1ce70_79", E = {
  summary: De,
  title: He,
  titleWrapper: We,
  isNested: Be,
  isExpanded: Oe,
  chevronIcon: Se,
  chevronIconExpanded: Te,
  dark: Ve,
  light: Ze
}, V = r(
  ({ title: n, isExpanded: t = !0, isNested: s = !1, variant: a = "dark", onClick: i }, o) => /* @__PURE__ */ e.createElement(
    "summary",
    {
      "aria-expanded": t,
      className: d(E.summary),
      onClick: i,
      ref: o
    },
    /* @__PURE__ */ e.createElement(
      "div",
      {
        className: d(E.titleWrapper, E[a], {
          [E.isExpanded]: t,
          [E.isNested]: s
        })
      },
      /* @__PURE__ */ e.createElement(
        w,
        {
          className: d(E.chevronIcon, {
            [E.chevronIconExpanded]: t
          }),
          icon: $e,
          size: "lg"
        }
      ),
      /* @__PURE__ */ e.createElement("div", { className: E.title }, n)
    )
  )
);
V.displayName = "AccordionHeader";
const H = r(function(t, s) {
  return /* @__PURE__ */ v.createElement(
    "svg",
    {
      fill: "none",
      ref: s,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      ...t
    },
    /* @__PURE__ */ v.createElement(
      "path",
      {
        clipRule: "evenodd",
        d: "M18.245 18.0385H5.75495C4.98009 18.0385 4.49963 17.1953 4.89465 16.5287L11.1397 5.9902C11.527 5.3366 12.4729 5.3366 12.8602 5.9902L19.1053 16.5287C19.5003 17.1953 19.0198 18.0385 18.245 18.0385ZM11.2874 9.28764C11.2671 8.88013 11.592 8.53857 12 8.53857C12.408 8.53857 12.7329 8.88013 12.7125 9.28764L12.525 13.0392C12.511 13.3189 12.2801 13.5386 12 13.5386C11.7199 13.5386 11.489 13.3189 11.475 13.0392L11.2874 9.28764ZM12 16.0386C12.425 16.0386 12.75 15.7136 12.75 15.2885C12.75 14.9761 12.5 14.5386 12 14.5386C11.575 14.5386 11.25 14.8761 11.25 15.2885C11.25 15.7136 11.5875 16.0386 12 16.0386Z",
        fill: "currentColor",
        fillRule: "evenodd"
      }
    )
  );
}), W = r(function(t, s) {
  return /* @__PURE__ */ v.createElement(
    "svg",
    {
      fill: "none",
      ref: s,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      ...t
    },
    /* @__PURE__ */ v.createElement(
      "path",
      {
        clipRule: "evenodd",
        d: "M12 19C15.866 19 19 15.866 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19ZM13.1666 8.49997C13.1666 9.1443 12.6443 9.66664 12 9.66664C11.3556 9.66664 10.8333 9.1443 10.8333 8.49997C10.8333 7.85564 11.3556 7.3333 12 7.3333C12.6443 7.3333 13.1666 7.85564 13.1666 8.49997ZM12 11C12.5523 11 13 11.4477 13 12V15.5C13 16.0523 12.5523 16.5 12 16.5C11.4477 16.5 11 16.0523 11 15.5V12C11 11.4477 11.4477 11 12 11Z",
        fill: "currentColor",
        fillRule: "evenodd"
      }
    )
  );
}), Fe = r(function(t, s) {
  return /* @__PURE__ */ v.createElement(
    "svg",
    {
      fill: "none",
      ref: s,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      ...t
    },
    /* @__PURE__ */ v.createElement(
      "path",
      {
        d: "M8 8L16 16M16 8L8 16",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeWidth: 2
      }
    )
  );
}), Xe = "_accordion_1ysxk_1", ze = {
  accordion: Xe
}, Z = r(
  ({
    children: n,
    renderTitle: t,
    isInitiallyExpanded: s = !0,
    isNested: a = !1,
    variant: i = "dark",
    onToggle: o
  }, l) => {
    const [c, _] = T(s), p = oe(
      (u) => {
        u.preventDefault(), _(!c), o && o(!c);
      },
      [c, o]
    );
    return /* @__PURE__ */ e.createElement(
      "details",
      {
        className: ze.accordion,
        "data-testid": "sports-expandable-accordion",
        open: c,
        ref: l
      },
      t({ isExpanded: c, isNested: a, variant: i, onClick: p }),
      n
    );
  }
);
Z.displayName = "Accordion";
const Ge = "_alert_qs948_1", Ke = "_square_qs948_9", Pe = "_aggressive_qs948_62", m = {
  alert: Ge,
  square: Ke,
  "passive-success": "_passive-success_qs948_13",
  "passive-information": "_passive-information_qs948_18",
  "passive-warning": "_passive-warning_qs948_23",
  "passive-destructive": "_passive-destructive_qs948_28",
  "passive-brand-update": "_passive-brand-update_qs948_33",
  "passive-aggressive": "_passive-aggressive_qs948_38",
  "passive-aggressive-success": "_passive-aggressive-success_qs948_42",
  "passive-aggressive-information": "_passive-aggressive-information_qs948_46",
  "passive-aggressive-warning": "_passive-aggressive-warning_qs948_50",
  "passive-aggressive-destructive": "_passive-aggressive-destructive_qs948_54",
  "passive-aggressive-brand-update": "_passive-aggressive-brand-update_qs948_58",
  aggressive: Pe,
  "alert-description": "_alert-description_qs948_65",
  "alert-dismiss-icon": "_alert-dismiss-icon_qs948_68",
  "aggressive-success": "_aggressive-success_qs948_72",
  "aggressive-information": "_aggressive-information_qs948_76",
  "aggressive-warning": "_aggressive-warning_qs948_80",
  "aggressive-destructive": "_aggressive-destructive_qs948_84",
  "aggressive-brand-update": "_aggressive-brand-update_qs948_88",
  "alert-title": "_alert-title_qs948_92",
  "alert-icon": "_alert-icon_qs948_103",
  "alert-dismiss-button": "_alert-dismiss-button_qs948_115"
}, Ue = "div", Je = [
  "warning",
  "destructive",
  "brand-update"
], Qe = (n) => Je.includes(n), Ye = r(
  ({
    as: n,
    title: t,
    variant: s = "passive",
    level: a,
    isSquare: i,
    onDismiss: o,
    dismissLabel: l,
    className: c,
    isCollapsible: _,
    children: p,
    ...u
  }, f) => {
    const C = n ?? Ue, y = Qe(a);
    return /* @__PURE__ */ e.createElement(
      C,
      {
        "aria-label": t,
        "aria-live": y ? "assertive" : "polite",
        className: d(
          m.alert,
          i ? m.square : void 0,
          m[s],
          m[`${s}-${a}`],
          s === "passive-aggressive" ? m[`passive-${a}`] : void 0,
          c
        ),
        ref: f,
        role: "alert",
        ...u
      },
      _ ? /* @__PURE__ */ e.createElement(
        Z,
        {
          renderTitle: (b) => /* @__PURE__ */ e.createElement(
            V,
            {
              ...b,
              title: /* @__PURE__ */ e.createElement("div", { className: m["alert-title"] }, /* @__PURE__ */ e.createElement(
                w,
                {
                  className: m["alert-icon"],
                  icon: y ? H : W,
                  size: "lg"
                }
              ), t ? /* @__PURE__ */ e.createElement("h2", null, t) : null)
            }
          ),
          variant: "transparent"
        },
        /* @__PURE__ */ e.createElement("div", { className: m["alert-description"] }, p)
      ) : /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("div", { className: m["alert-title"] }, /* @__PURE__ */ e.createElement(
        w,
        {
          className: m["alert-icon"],
          icon: y ? H : W,
          size: "lg"
        }
      ), t ? /* @__PURE__ */ e.createElement("h2", null, t) : p, o ? /* @__PURE__ */ e.createElement(
        "button",
        {
          "aria-label": l,
          className: m["alert-dismiss-button"],
          onClick: o,
          type: "button"
        },
        /* @__PURE__ */ e.createElement(
          w,
          {
            className: m["alert-dismiss-icon"],
            icon: Fe,
            size: "lg"
          }
        )
      ) : null), t ? /* @__PURE__ */ e.createElement("span", { className: m["alert-description"] }, p) : null)
    );
  }
);
Ye.displayName = "Alert";
const et = "_button_1j8jb_1", tt = "_small_1j8jb_19", st = "_inline_1j8jb_25", nt = "_fullWidth_1j8jb_29", at = "_primary_1j8jb_34", ot = "_secondary_1j8jb_64", it = "_tertiary_1j8jb_91", lt = "_iconRight_1j8jb_143", h = {
  button: et,
  small: tt,
  inline: st,
  fullWidth: nt,
  primary: at,
  secondary: ot,
  tertiary: it,
  "brand-promotion": "_brand-promotion_1j8jb_121",
  iconRight: lt
}, rt = "button", ct = r(
  ({
    as: n,
    className: t,
    children: s,
    variant: a = "primary",
    size: i = "normal",
    fullWidth: o,
    icon: l,
    iconPosition: c = "left",
    ..._
  }, p) => {
    const u = n ?? rt;
    return /* @__PURE__ */ e.createElement(
      u,
      {
        type: u === "button" ? "button" : void 0,
        ..._,
        className: d(
          h.button,
          h[a],
          {
            [h.small]: i === "small",
            [h.iconRight]: l && c === "right",
            [h.inline]: !o,
            [h.fullWidth]: o
          },
          t
        ),
        ref: p
      },
      l ? /* @__PURE__ */ e.createElement(w, { icon: l }) : null,
      s
    );
  }
);
ct.displayName = "Button";
const dt = "div", _t = r(
  ({
    as: n,
    className: t,
    children: s,
    padded: a = !1,
    ...i
  }, o) => {
    const l = n ?? dt;
    return /* @__PURE__ */ e.createElement(
      l,
      {
        ...i,
        className: d(
          N.card,
          { [N.padded]: a },
          t
        ),
        ref: o
      },
      s
    );
  }
);
_t.displayName = "Card";
const L = {
  XXS: 4,
  XS: 8,
  SM: 12,
  MD: 16,
  LG: 24,
  XL: 32,
  XXL: 40
}, mt = "_dropdown_10wdf_1", pt = "_overlay_10wdf_13", ut = "_title_10wdf_17", gt = "_body_10wdf_30", vt = "_padded_10wdf_36", k = {
  dropdown: mt,
  overlay: pt,
  title: ut,
  body: gt,
  padded: vt
}, B = 14, O = 1, ft = r(
  ({
    children: n,
    triggerEl: t,
    title: s,
    padded: a = !1,
    verticalOffset: i = "XS",
    dropdownRole: o = "dialog",
    overlay: l = !1,
    overlayProps: c = {},
    isDefaultOpen: _ = !1,
    isOpenCallback: p,
    ...u
  }, f) => {
    const [C, y] = T(_), b = $(null), I = $(), F = (g) => {
      y(g), p?.(g);
    }, { refs: M, strategy: X, x: z, y: G, context: R } = ie({
      open: C,
      onOpenChange: F,
      placement: "bottom-start",
      strategy: "absolute",
      middleware: [
        le({
          mainAxis: L[i]
        }),
        re({
          element: b
        }),
        ce({
          padding: L.MD,
          apply({ availableWidth: g, elements: q, middlewareData: A }) {
            if (Object.assign(q.floating.style, {
              width: `${g}px`,
              maxHeight: `${window.innerHeight - q.reference.getBoundingClientRect().bottom - (A.offset?.y ?? 0) - L.MD}px`
            }), A.arrow && b.current && I.current) {
              const { left: te } = q.reference.getBoundingClientRect(), { left: se, width: ne } = I.current.getBoundingClientRect(), ae = se - te - (B / 2 + O) + ne / 2;
              Object.assign(b.current.style, {
                left: `${Math.trunc(ae)}px`
              });
            }
          }
        })
      ],
      whileElementsMounted(...g) {
        return de(...g, { ancestorScroll: !1 });
      }
    }), K = _e(R), P = me(R, {
      outsidePressEvent: "mousedown"
    }), U = pe(R, { role: o }), J = ue([M.setFloating, ...f ? [f] : []]), { getFloatingProps: Q, getReferenceProps: Y } = ge([
      K,
      P,
      U
    ]), ee = (g) => {
      g.key === "Enter" && y(!1);
    };
    return /* @__PURE__ */ e.createElement(e.Fragment, null, t({ refs: M, getReferenceProps: Y, arrowRef: I, isOpen: C }), l && C ? /* @__PURE__ */ e.createElement(
      ve,
      {
        ...c,
        className: d(k.overlay, c.className)
      }
    ) : null, C ? /* @__PURE__ */ e.createElement(
      "div",
      {
        ...u,
        className: k.dropdown,
        ref: J,
        style: {
          position: X,
          top: G ?? 0,
          left: z ?? 0
        },
        ...Q()
      },
      s ? /* @__PURE__ */ e.createElement(
        "span",
        {
          className: d(k.title),
          onKeyDown: (g) => ee(g),
          role: "button",
          tabIndex: 0
        },
        s
      ) : null,
      /* @__PURE__ */ e.createElement(
        "div",
        {
          className: d(k.body, { [k.padded]: a })
        },
        n
      ),
      /* @__PURE__ */ e.createElement(
        fe,
        {
          context: R,
          fill: "#ECECEC",
          ref: b,
          stroke: "#999",
          strokeWidth: O,
          width: B
        }
      )
    ) : null);
  }
);
ft.displayName = "Dropdown";
const Et = r(function(t, s) {
  return /* @__PURE__ */ v.createElement(
    "svg",
    {
      fill: "none",
      ref: s,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      ...t
    },
    /* @__PURE__ */ v.createElement(
      "path",
      {
        clipRule: "evenodd",
        d: "M7 8C7 7.44772 7.44771 7 8 7H10.5C11.0523 7 11.5 6.55228 11.5 6C11.5 5.44772 11.0523 5 10.5 5H8C6.34315 5 5 6.34314 5 8V16.871C5 18.5278 6.34314 19.871 8 19.871H16.871C18.5278 19.871 19.871 18.5278 19.871 16.871V14C19.871 13.4477 19.4233 13 18.871 13C18.3187 13 17.871 13.4477 17.871 14V16.871C17.871 17.4233 17.4233 17.871 16.871 17.871H8C7.44772 17.871 7 17.4233 7 16.871V8ZM14.129 5C13.5767 5 13.129 5.44772 13.129 6C13.129 6.55228 13.5767 7 14.129 7H16.3244L8.70664 14.0737C8.30193 14.4495 8.2785 15.0822 8.6543 15.4869C9.0301 15.8916 9.66283 15.915 10.0675 15.5392L17.871 8.29321V10.5367C17.871 11.0889 18.3187 11.5367 18.871 11.5367C19.4232 11.5367 19.871 11.0889 19.871 10.5367V6C19.871 5.44772 19.4232 5 18.871 5H14.129Z",
        fill: "currentColor",
        fillRule: "evenodd"
      }
    )
  );
}), wt = "_link_56gj4_1", Ct = "_embedded_56gj4_23", yt = "_standalone_56gj4_32", j = {
  link: wt,
  embedded: Ct,
  standalone: yt
}, bt = "a", ht = r(
  ({
    as: n,
    className: t,
    children: s,
    standalone: a,
    isExternal: i,
    ...o
  }, l) => {
    const c = n ?? bt, { startIcon: _, endIcon: p, ...u } = {
      startIcon: void 0,
      endIcon: void 0,
      ...o
    }, f = i ? Et : p;
    return /* @__PURE__ */ e.createElement(
      c,
      {
        target: i ? "_blank" : void 0,
        ...u,
        className: d(
          j.link,
          {
            [j.embedded]: !a,
            [j.standalone]: a
          },
          t
        ),
        ref: l
      },
      typeof _ < "u" ? /* @__PURE__ */ e.createElement(w, { icon: _ }) : null,
      typeof _ < "u" || typeof f < "u" ? /* @__PURE__ */ e.createElement("span", null, s) : s,
      f ? /* @__PURE__ */ e.createElement(w, { icon: f }) : null
    );
  }
);
ht.displayName = "Link";
const xt = "_tag_1x9g6_1", Nt = "_notification_1x9g6_11", S = {
  tag: xt,
  notification: Nt
}, kt = r(
  ({ variant: n = "notification", className: t, children: s, ...a }, i) => /* @__PURE__ */ e.createElement(
    "strong",
    {
      className: d(S.tag, S[n], t),
      ref: i,
      ...a
    },
    s
  )
);
kt.displayName = "Tag";
const Rt = "_timeline_ckebo_1", x = {
  timeline: Rt,
  "timeline-list-item": "_timeline-list-item_ckebo_7",
  "timeline-node-line": "_timeline-node-line_ckebo_11",
  "timeline-node": "_timeline-node_ckebo_11",
  "timeline-node-period": "_timeline-node-period_ckebo_24",
  "timeline-child-container": "_timeline-child-container_ckebo_39"
}, qt = r(
  ({ className: n, children: t, ...s }, a) => /* @__PURE__ */ e.createElement("ol", { className: d(x.timeline, n), ref: a, ...s }, t)
);
qt.displayName = "Timeline";
const It = r(
  ({ children: n, ...t }, s) => /* @__PURE__ */ e.createElement("li", { className: x["timeline-list-item"], ref: s, ...t }, /* @__PURE__ */ e.createElement("div", { className: x["timeline-node"] }, /* @__PURE__ */ e.createElement("span", { className: x["timeline-node-period"] }), /* @__PURE__ */ e.createElement("span", { className: x["timeline-node-line"] })), /* @__PURE__ */ e.createElement("div", { className: x["timeline-child-container"] }, n))
);
It.displayName = "TimelineItem";
export {
  Z as Accordion,
  V as AccordionHeader,
  Ye as Alert,
  ct as Button,
  _t as Card,
  he as CardGroup,
  ft as Dropdown,
  w as Icon,
  ht as Link,
  kt as Tag,
  qt as Timeline,
  It as TimelineItem
};
